import cloneDeep from 'lodash.clonedeep';

import { KycIdentificationState } from '@core/store/kyc-identification/kyc-identification-reducer';
import { AppStoreState } from '@interfaces/app-store-state';

export const kycIdentificationSelector = (state: AppStoreState): KycIdentificationState =>
  state?.kycIdentification ? cloneDeep(state.kycIdentification) : null;

export const kycIdentificationWorkflowUuidSelector = (state: AppStoreState): string | null =>
  state?.kycIdentification?.workflowUuid ?? null;
